import { AccountType } from "../api/enums"
import { User } from "../api/types"
import { Event } from "./events"

export const canExportImport = (user?: User, event?: Event) => {
	return user && ((user.accountType as number) >= (AccountType.Basic as number) || event?.unlocked)
}
